<template>
    <form @submit.prevent="$emit('submit')" class="space-y-6">
        <FormSection>
            <template #title>
                Attendance Information
            </template>

            <div class="row">
                <div class="col-full md:col-1/2">
                    <FormGroup
                        name="attended"
                        label="Attended"
                        inline>
                        <Radio name="attended" v-model="form.attended" :value="true"/>
                    </FormGroup>
                </div>
                <div class="col-full md:col-1/2">
                    <FormGroup
                        name="attended"
                        label="Absent"
                        inline>
                        <Radio name="attended" v-model="form.attended" :value="false"/>
                    </FormGroup>
                </div>
            </div>

            <FormGroup
                name="feedback"
                label="Feedback">
                <Textarea name="feedback" v-model="form.feedback" :rows="5"/>
            </FormGroup>

            <template v-if="$slots.footer" #footer>
                <slot name="footer"></slot>
            </template>
        </FormSection>
    </form>
</template>

<script>

import FormSection from "@/Components/Form/FormSection.vue";
import FormGroup from "@/Components/Form/FormGroup.vue";
import Textarea from "@/Components/Form/Textarea.vue";
import InputError from "@/Components/Form/InputError.vue";
import Radio from "@/Components/Form/Radio.vue";

export default {

    name: "CourseRecordForm",

    emits: ['submit'],

    inject: ['form'],

    components: {
        FormSection,
        FormGroup,
        Radio,
        Textarea,
        InputError,
    },
};

</script>
